module.exports = __webpack_public_path__ + "static/media/deactiveBill.ed703abe.svg";